import React from "react";

const Stratagy = () => {
  return <div>Stratagy</div>;
};

export default Stratagy;
